<template>
	<div>
        <section class="hero is-success">
            <div class="hero-body">
                <p class="title">
                    Het is gelukt
                </p>
                <p class="subtitle">
                    U krijgt een bevestiging via de mail
                </p>
            </div>
        </section>
	</div>
</template>

<script>
export default {
  name: 'Success',
  data () {
    return {
    }
  },

  mounted() {
   
  },

  components: {
    
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Success.vue